/**
 * Define a single instance of the Query Client to use for all app queries.
 * This allows queries to know about each other.
 */

import { QueryClient } from 'react-query';
import { AxiosError } from 'axios';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: (failureCount, error): boolean => {
                if (failureCount === 3) {
                    return false;
                }
                if (typeof (error as AxiosError)?.response?.status === 'number') {
                    // @ts-ignore
                    if ((error as AxiosError).response.status < 500) {
                        return false;
                    }
                }
                return true;
            },
        },
    },
});

export default queryClient;
